module.exports = __webpack_public_path__ + "img/2020_09_dande_singapore_fin_web.a22cb8f2.png";